// extracted by mini-css-extract-plugin
export default {"list--group":"Tz6Wg"};